import { render, staticRenderFns } from "./active-tasks.vue?vue&type=template&id=112007ec"
import script from "./active-tasks.vue?vue&type=script&lang=js"
export * from "./active-tasks.vue?vue&type=script&lang=js"
import style0 from "./active-tasks.vue?vue&type=style&index=0&id=112007ec&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports